import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import type { ApiError } from '@/core/api';
import * as api from './api';
import type { ReportScheduleInput } from './types';

export const scheduleKeys = {
  all: ['report-schedules'] as const,
  list: () => [...scheduleKeys.all, 'list'] as const,
};

export function useReportSchedules() {
  return useQuery({
    queryKey: scheduleKeys.list(),
    queryFn: () => api.listSchedules(),
  });
}

export function useCreateReportSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ReportScheduleInput) => api.createSchedule(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: scheduleKeys.list() });
      toast.success('Scheduled report created');
    },
    onError: (err: ApiError) => {
      if (!err.fieldErrors) toast.error(err.message);
    },
  });
}

export function useDeleteReportSchedule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.deleteSchedule(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: scheduleKeys.list() });
      toast.success('Schedule deleted');
    },
    onError: (err: ApiError) => toast.error(err.message),
  });
}
